'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  // baseURL:'"https://dgserver.zsxsgzc.cn"',
  // fileURL:'"https://dgserver.zsxsgzc.cn"',
  baseURL:'"http://192.168.100.138:6686"',
  fileURL:'"http://192.168.100.138:6686"',
  // baseURL:'"https://mock.apifox.cn/m1/2599297-0-default"',
  // baseURL: '"http://test02.gznotary.com"',
  // fileURL: '"http://test02.gznotary.com"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 33